import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#sobre", label: "Sobre" },
  { href: "#produtos", label: "Produtos" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#contato", label: "Contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
        scrolled || open
          ? "py-3 backdrop-blur-xl bg-espresso/95 border-b border-cream/10"
          : "py-6 bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <a href="#top" className="group" data-testid="site-logo">
          <div className="flex items-baseline gap-2 leading-none">
            <span className="font-display text-cream text-2xl md:text-[28px] tracking-tight italic font-medium">
              Empório
            </span>
            <span className="font-mono text-gold text-[10px] tracking-[0.32em] uppercase">
              do café
            </span>
          </div>
          <div className="h-px w-0 group-hover:w-full bg-gold/70 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="font-body text-[13px] tracking-wide text-cream/80 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://wa.me/5535999516948"
          target="_blank"
          rel="noreferrer"
          data-testid="header-cta-whatsapp"
          className="hidden md:inline-flex btn-gold text-[13px] py-2.5 px-5"
        >
          Falar no WhatsApp
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-cream p-2 rounded-full border border-cream/20 bg-espresso/40 backdrop-blur-sm"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden fixed inset-0 top-[60px] z-40 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          open ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
        }`}
        data-testid="mobile-menu"
      >
        {/* Backdrop overlay */}
        <div 
          className="absolute inset-0 bg-espresso/80 backdrop-blur-xl" 
          onClick={() => setOpen(false)}
        />
        
        <div className="relative mx-6 mt-4 rounded-[20px] bg-espresso/95 border border-cream/10 p-6 flex flex-col gap-5 shadow-2xl overflow-y-auto max-h-[calc(100vh-100px)]">
          {links.map((l, i) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-display text-cream text-xl tracking-tight hover:text-gold transition-colors py-1"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              {l.label}
            </a>
          ))}
          <div className="h-px bg-cream/10 my-1 shrink-0" />
          <a
            href="https://wa.me/5535999516948"
            target="_blank"
            rel="noreferrer"
            className="btn-gold justify-center text-[13px] py-2 px-6 w-fit mx-auto shrink-0"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>

  );
}
